<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                       <div class="card">
                           <div class="card-body">
                               <div class="px-3">
                                   <h2>Articles</h2>
                                   <table class="table table-responsive-sm">
                                       <thead>
                                           <th>
                                               Title
                                           </th>
                                           <th>
                                               Published
                                           </th>
                                           <th>
                                               Published at
                                           </th>
                                           <th>
                                               Actions
                                           </th>
                                       </thead>
                                       <tbody>
                                           <tr v-for="article in articles"  :key="article._id">
                                               <td>
                                                   {{ article.title }}
                                               </td>
                                               <td>
                                                   {{ article.published }}
                                               </td>
                                               <td>
                                                   {{ formatDate(article.publishedAt) }}
                                               </td>
                                               <td>
                                                   <a href="" @click.prevent="editArticle(article._id)"><i class="fa fa-pencil font-medium-3 mr-2"></i></a>
                                                   <a href="" @click.prevent="deleteArticle(article)"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                                               </td>
                                           </tr>
                                       </tbody>
                                   </table>
                               </div>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsService from '@/services/news'
import moment from 'moment'

export default {
    data() {
        return {
            articles: []
        }
    },
    methods: {
        formatDate(d) {
            return moment(new Date(d)).format('YYYY-MM-DD HH:mm')
        },
        editArticle(id) {
          this.$router.push({ name: 'editArticle', params: { id: id }})
        },
        deleteArticle: async function(article) {
            let result = await NewsService.delete(article)
            if (result) {
                alert("Deleted")
            }
        }
    },
    mounted: async function() {
        let result = await NewsService.index()
        if (result) {
            console.log(result.data)
            this.articles = result.data
        }
    }

}
</script>

<style lang="scss">
    .px-3 {
        padding: 15px;
        box-sizing: border-box;
    }
</style>


